import moment from "moment"

export const unitMappings = {
  W: ["W", "kW", "MW", "GW"],
  kWp: ["kWp", "MWp", "GWp", "TWp", "PWp"],
  kWh: ["kWh", "MWh", "GWh", "TWh", "PWh"],
  kg: ["kg", "t", "kt"],
}

export const convertUnit = (value, unit) => {
  if (!unit || !(unit in unitMappings)) {
    return `${value}`
  }

  const units = unitMappings[unit]
  let newValue = value
  let newUnitIndex = 0

  // Chia cho 1000 lặp cho tới khi không thể chia nữa hoặc đạt đơn vị cao nhất
  while (newValue >= 1000 && newUnitIndex < units.length - 1) {
    newValue /= 1000
    newUnitIndex++
  }

  // Làm tròn tới 2 chữ số thập phân
  newValue = parseFloat(newValue.toFixed(2))

  // Giới hạn tổng số chữ số không quá 5 (loại bỏ decimal nếu cần)
  const valueStr = newValue.toString()
  if (valueStr.replace(".", "").length > 5) {
    const [intPart] = valueStr.split(".")
    const maxDecLength = Math.max(0, 5 - intPart.length)
    newValue = parseFloat(newValue.toFixed(maxDecLength))
  }

  return `${newValue} ${units[newUnitIndex]}`
}

export const customDate = (dateStr, inputFormat, outputFormat) => {
  const m = moment(dateStr, inputFormat, true)
  return m.isValid() ? m.format(outputFormat) : dateStr
}

export const getStatusColor = (siteStatus) => {
  switch (Number(siteStatus)) {
    case 2: // ZeroExport
      return { border: "#F4B400", tint: "rgba(244, 180, 0, 0.08)", shadow: "rgba(244, 180, 0, 0.22)" }
    case 3: // Abnormal
      return { border: "#FF8A00", tint: "rgba(255, 136, 0, 0.13)", shadow: "rgba(255, 138, 0, 0.22)" }
    case 4: // OfflineOrNoData
      return { border: "#E53935", tint: "rgba(229, 57, 53, 0.21)", shadow: "rgba(229, 57, 53, 0.22)" }
    case 1: // Normal
    default:
      return null
  }
}

export const getCardStyle = (plant, isSelected) => {
  const st = Number(plant?.siteStatus)

  // NORMAL
  if (st === 1 || !st) {
    return {
      border: isSelected ? "1px solid #00AEEC" : "1px solid #ddd",
      background: isSelected ? "rgba(0, 187, 255, 0.20)" : "#F3F3F3",
      boxShadow: isSelected ? "0 4px 12px rgba(0,170,255,0.2)" : "0 2px 6px rgba(0,0,0,0.05)",
    }
  }

  // Các status khác
  const c = getStatusColor(st)
  return {
    border: `1px solid ${c.border}`,
    background: isSelected ? c.tint : "#F3F3F3",
    boxShadow: isSelected ? `0 4px 12px ${c.shadow}` : "0 2px 6px rgba(0,0,0,0.05)",
  }
}
